
const setLang = (value, data, type) => {
    // value当前值， data全部数据
    let str = value;
    if (type == '简体中文') {
        str = data.find((item) => {
            return item.en == value;
        }) ? data.find((item) => {
            return item.en == value;
        }).zh : str;
    }
    return str;
};

export {
     setLang
}


// WEBPACK FOOTER //
// ./src/js/common.js